import { useEffect, useState } from 'react'
import { getPricing } from '../lib/api'
import type { PricingItem } from '../lib/types'

export default function Pricing() {
  const [items, setItems] = useState<PricingItem[]>([])
  const [loading, setLoading] = useState(true)
  const load = async () => { setLoading(true); try { setItems(await getPricing()) } finally { setLoading(false) } }
  useEffect(() => { load() }, [])
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-white text-lg font-semibold">定价对比 <span className="text-muted text-sm font-normal">· {items.length} 个</span></h2>
        <button onClick={load} disabled={loading} className="text-muted text-sm hover:text-white disabled:opacity-50">{loading ? '刷新中...' : '↻ 刷新'}</button>
      </div>
      <div className="bg-card border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead className="bg-bg/50 text-muted text-xs">
            <tr>
              <th className="text-left px-3 py-2 font-normal">标的</th>
              <th className="text-right px-3 py-2 font-normal">价格</th>
              <th className="text-right px-3 py-2 font-normal">涨跌</th>
              <th className="text-right px-3 py-2 font-normal">PE</th>
              <th className="text-right px-3 py-2 font-normal">PB</th>
              <th className="text-right px-3 py-2 font-normal">市值</th>
              <th className="text-right px-3 py-2 font-normal">信号</th>
            </tr>
          </thead>
          <tbody>
            {items.map(p => (
              <tr key={p.ticker} className="border-t border-border">
                <td className="px-3 py-2">
                  <div className="text-white">{p.name}</div>
                  <div className="text-muted text-xs">{p.ticker} · {p.currency}</div>
                </td>
                <td className="text-right px-3 py-2 text-white">{p.price}</td>
                <td className={`text-right px-3 py-2 font-semibold ${(p.change_pct ?? 0) >= 0 ? 'text-red' : 'text-teal'}`}>
                  {p.change_pct != null ? `${p.change_pct > 0 ? '+' : ''}${p.change_pct}%` : '-'}
                </td>
                <td className="text-right px-3 py-2 text-muted">{p.pe ?? '-'}</td>
                <td className="text-right px-3 py-2 text-muted">{p.pb ?? '-'}</td>
                <td className="text-right px-3 py-2 text-muted">{p.mcap_b ?? '-'}</td>
                <td className="text-right px-3 py-2 text-blue">{p.signal}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && items.length === 0 && <div className="text-muted py-12 text-center">暂无定价数据</div>}
      </div>
    </div>
  )
}
